import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseApiTemplateService } from '../../shared/base-api-template-service.model';
import { Core2Config } from '../../shared/core2Config';
import { PeppolApTntCompReceiverMappingContainerModel } from '../../../../../../models/aggregates/e-invoice/peppol/bl_ppl_ap_tnt_comp_receiver_mapping_container.model';
import { ApiVisa } from '../../shared/api-visa.model';
import { Observable } from 'rxjs';
import { ApiResponseModel, BasicApiResponseModel, PagingResponseModel } from '../../shared/api-response.model';
import { Pagination } from '../../shared/pagination.model';

@Injectable({
  providedIn: 'root'
})
export class PeppolApTntCompReceiverMappingService extends BaseApiTemplateService<PeppolApTntCompReceiverMappingContainerModel> {

  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'ppl/ap-tnt-comp-receiver-mappings'

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'ppl/ap-tnt-comp-receiver-mappings'
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'ppl/ap-tnt-comp-receiver-mappings'
    this.httpClient = http;
  }

  getTntCompReceiverMapping(crossTenantCode: string,visa: ApiVisa): Observable<ApiResponseModel<any>> {
    let customUrl;
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
      customUrl = this.apiUrl + `/${crossTenantCode}/cross-tenant-login-ep`

    }
    return this.httpClient.get<ApiResponseModel<any>>(
      customUrl,
      this.getHttpHeader(visa)
    );
  }

  getTntCompReceiverMappingByCriteria(
    crossTenantCode: string,
    pagination: Pagination,
    visa: ApiVisa,
    criteria?: any,
  ): Observable<PagingResponseModel<any>> {
    let customUrl;
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
      customUrl = this.apiUrl + `/${crossTenantCode}/cross-tenant-login-ep`
    }
    const UrlByCriteria =
      customUrl + '/query?' + pagination.getQueryKeyValues();
    return this.httpClient.get<PagingResponseModel<any>>(
      UrlByCriteria,
      this.getHttpHeader(visa)
    );
  }

  getTntCompReceiverMappingByGuid(
    crossTenantCode: string,
    guid: string,
    visa: ApiVisa
  ): Observable<BasicApiResponseModel<any>> {
    let customUrl;
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
      customUrl = this.apiUrl + `/${crossTenantCode}/cross-tenant-login-ep`
    }
    return this.httpClient.get<BasicApiResponseModel<any>>(
      customUrl + '/' + guid,
      this.getHttpHeader(visa)
    );
  }
}
